<template>
  <div>
    <div
      class="max-w-lg mx-auto lg:max-w-7xl border-b-2 border-gray-100 px-8 xl:px-4 pt-8 pb-4"
    >
      <div class="mt-2 md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0">
          <h2
            class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
          >
            {{ title }}
          </h2>
          <span
            v-if="admin"
            class="inline-block rounded-full bg-indigo-500 text-white text-base font-bold px-2 mt-2"
            >Администрирование</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="app-page-header text-center py-5">
    <h1 class="app-page-title">{{ title }}</h1>
    <span v-if="admin" class="badge badge-pill header__badge d-inline-flex"
      >Администрирование</span
    >
  </div> -->

  <!-- <div class="custom-header d-flex flex-column align-items-center">
      <div class="header__text d-flex justify-content-center">
        
      </div>     
      
    </div> -->
  <!--
<div id="page_title" class="header-h1 header-h1-left" style="margin: 0; padding-top: 20px; padding-bottom: 10px; padding-left: 20px;">
  <h1>{{ title }}</h1>
  <p v-if="admin" class="badge rounded-pill bg-danger text-light">Администрирование</p>
</div>
--></template>


<script>
export default {
  data() {
    return {};
  },
  props: {
    title: String,
    admin: Boolean,
  },
  mounted() {},
};
</script>

